import { render, staticRenderFns } from "./ActivityPane.vue?vue&type=template&id=ebf96bee&scoped=true"
import script from "./ActivityPane.vue?vue&type=script&lang=js"
export * from "./ActivityPane.vue?vue&type=script&lang=js"
import style0 from "./ActivityPane.vue?vue&type=style&index=0&id=ebf96bee&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf96bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebf96bee')) {
      api.createRecord('ebf96bee', component.options)
    } else {
      api.reload('ebf96bee', component.options)
    }
    module.hot.accept("./ActivityPane.vue?vue&type=template&id=ebf96bee&scoped=true", function () {
      api.rerender('ebf96bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/ HundredDayOath/compoents/ActivityPane.vue"
export default component.exports